export class DashboardWithGraphs {
    'id';
    'name';
    'createdAt';
    'updatedAt';
    'graphs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "graphs",
            "baseName": "graphs",
            "type": "Array<DashboardGraph>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DashboardWithGraphs.attributeTypeMap;
    }
    constructor() {
    }
}
